import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { svgIconColors } from '@/components/ui/SvgIcon/SvgIconBase';
const shadows = {
    lg: 'drop-shadow-lg',
    md: 'drop-shadow-md',
    sm: 'drop-shadow-sm',
};
const sizes = {
    lg: 'w-[60px] h-[60px]',
    md: 'w-[48px] h-[48px]',
    sm: 'w-[40px] h-[40px]',
};
/**
 * 丸型のアイコンのみ表示するボタンコンポーネント
 * NOTE: デザインシステムのルールに基づいて値を設定をしています
 * WARNING: 設定値の変更, 追加をする場合は、デザインデータの更新必須（none 等は例外）
 * @param props
 * @returns
 */
export const CircleIconButton = (props) => {
    const { className = '', dataAttributes = {}, disabled = false, icon: Icon, onClick = () => { }, shadow = 'sm', size, style = {}, tagName = 'button', } = props;
    const commonProps = useMemo(() => (Object.assign({ className: clsx('inline-flex items-center justify-center', 'flex-shrink-0', [
            svgIconColors.base,
            'hover:text-link group-hover:text-link',
            'active:text-link group-active:text-link',
        ], 'bg-gray-50 border border-solid border-gray-100 rounded-full', 'active:drop-shadow-none group-active:drop-shadow-none', 'hover:cursor-pointer group-hover:cursor-pointer', shadows[shadow], sizes[size], className), style }, dataAttributes)), [className, dataAttributes, shadow, size, style]);
    const iconProps = useMemo(() => ({ color: 'current', size: 'sm' }), []);
    if (tagName === 'button') {
        return (_jsx("button", Object.assign({}, commonProps, { disabled: disabled, onClick: onClick, type: 'button' }, { children: _jsx(Icon, Object.assign({}, iconProps)) })));
    }
    const Tag = tagName;
    return (_jsx(Tag, Object.assign({}, commonProps, { children: _jsx(Icon, Object.assign({}, iconProps)) })));
};
export const circleIconButtonSizes = sizes;
export const circleIconButtonShadows = shadows;
